import a from "axios";
function m(t, r) {
  return a.get(`${r || "https://mpgateway.tcgplayer.com/"}v1/cart/${t}/summary/count`, {
    withCredentials: !0
  });
}
export {
  m as getCartSummary
};
//# sourceMappingURL=cartCount.api-es.js.map
